import React, { useId, useState } from 'react';
import { BellRing, Check } from 'lucide-react';
import { shopApi } from './api.js';

const KEY = '3dlabs.storeWishlist';
const joined = () => { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; } };

// Shown in place of the buy buttons while a product cannot be bought yet: leave an email and get one message when it
// goes on sale. The address is deleted once that message is sent.
export default function Wishlist({ product }) {
  const id = useId();
  const [email, setEmail] = useState('');
  const [state, setState] = useState(() => joined().includes(product.slug) ? 'done' : 'idle');
  const [error, setError] = useState('');
  const beta = product.purchase_availability === 'beta';
  const submit = async (event) => {
    event.preventDefault();
    if (state === 'busy') return;
    setState('busy'); setError('');
    try {
      await shopApi(`/public/store/products/${encodeURIComponent(product.slug)}/wishlist`, { method: 'POST', body: { email: email.trim() } });
      try { localStorage.setItem(KEY, JSON.stringify([...new Set([...joined(), product.slug])].slice(-60))); } catch { /* private mode */ }
      setState('done');
    } catch (problem) { setError(problem.message || 'That did not go through. Try again.'); setState('idle'); }
  };
  if (state === 'done') return <div className="buy-wish is-done" role="status"><Check aria-hidden="true" /><span><b>You are on the list.</b> We will email you once, when {product.name} goes on sale.</span></div>;
  return <form className="buy-wish" onSubmit={submit} noValidate>
    <label htmlFor={id}><BellRing aria-hidden="true" />{beta ? 'Be the first to know when it goes on sale' : 'Tell me when it is available'}</label>
    <div className="buy-wish-row">
      <input id={id} type="email" inputMode="email" autoComplete="email" required maxLength={200} placeholder="you@example.com" value={email} disabled={state === 'busy'} onChange={(event) => setEmail(event.target.value)} />
      <button type="submit" className="shop-btn" disabled={state === 'busy' || !email.trim()} aria-busy={state === 'busy' || undefined}>{state === 'busy' ? <span className="shop-spinner buy-spin" aria-hidden="true" /> : null}Notify me</button>
    </div>
    {error ? <small className="buy-wish-error" role="alert">{error}</small> : <small>One email when it goes on sale. Then your address is deleted.</small>}
  </form>;
}
